var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-responsive-container website-page cms-website",class:[`preview-layout-${_vm.$store.state.previewMode}`, `menu-anchor-${_vm.cmsWebsite.menu.block.anchor}`],style:([_vm.websiteStyle, _vm._pageStyle])},[_vm._t("above"),_c('div',{staticClass:"scrollable-content overflow"},[_vm._t("default")],2),_vm._t("below")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }